<div class="page" *ngIf="loading">
  <div class="page__glow" aria-hidden="true"></div>
  <div class="page__inner">
    <div class="state-card">
      <div class="state-card__spinner" aria-hidden="true"></div>
      <h2>Chargement…</h2>
      <p>Récupération du produit en cours.</p>
    </div>
  </div>
</div>

<div class="page page--ready" *ngIf="!loading && product as p; else notFound">
  <div class="page__glow" aria-hidden="true"></div>

  <div class="page__inner">
    <a class="back" routerLink="/accueil" fragment="produits">
      <span class="back__icon"><mat-icon>arrow_back</mat-icon></span>
      Retour aux produits
    </a>

    <section class="hero">
      <div class="hero__media">
        <img
          class="hero__img"
          [src]="imageUrl"
          [alt]="p.name"
          referrerpolicy="no-referrer"
          (error)="onImageError($event)" />
        <div class="hero__media-shade" aria-hidden="true"></div>
      </div>

      <div class="hero__panel">
        <div class="hero__accent" aria-hidden="true"></div>

        <span class="hero__eyebrow">
          <mat-icon>verified</mat-icon>
          Saarvie
        </span>

        <h1 class="hero__title">{{ p.name }}</h1>
        <p class="hero__desc">{{ p.description || ('Découvrez ' + p.name) }}</p>

        <div class="hero__meta">
          <span class="meta-pill">
            <mat-icon>layers</mat-icon>
            {{ getPackages(p).length }} package{{ getPackages(p).length > 1 ? 's' : '' }}
          </span>
          <span class="meta-pill">
            <mat-icon>menu_book</mat-icon>
            {{ getDescriptions(p).length }} info{{ getDescriptions(p).length > 1 ? 's' : '' }}
          </span>
          <span class="meta-pill" *ngIf="p.urlTerm || p.urlNote">
            <mat-icon>folder_open</mat-icon>
            Documents
          </span>
        </div>

        <div class="hero__actions">
          <a
            class="btn btn--primary"
            [routerLink]="['/souscription', p.id]">
            <mat-icon>shopping_cart</mat-icon>
            Souscrire maintenant
          </a>
          <a
            class="btn btn--ghost"
            *ngIf="p.urlTerm"
            [href]="p.urlTerm"
            target="_blank"
            rel="noopener noreferrer">
            <mat-icon>description</mat-icon>
            Conditions générales
          </a>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="content__head">
        <div class="content__accent" aria-hidden="true"></div>
        <div>
          <h2 class="content__title">Tout savoir sur {{ p.name }}</h2>
          <p class="content__subtitle">Descriptions, garanties et documents utiles</p>
        </div>
      </div>

      <div class="detail-shell">
        <mat-tab-group class="tabs" [(selectedIndex)]="selectedTabIndex" animationDuration="250ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">info</mat-icon>
              Description
            </ng-template>

            <div class="tab-content">
              <div class="info-grid" *ngIf="getDescriptions(p).length; else fallbackDesc">
                <article
                  class="info-card"
                  *ngFor="let d of getDescriptions(p); let i = index"
                  [style.animation-delay]="(i * 60) + 'ms'">
                  <div class="info-card__index">{{ i + 1 | number:'2.0-0' }}</div>
                  <h3 class="info-card__title">{{ d.name }}</h3>
                  <p class="info-card__text" style="white-space: pre-line">{{ d.description }}</p>
                </article>
              </div>

              <ng-template #fallbackDesc>
                <article class="info-card info-card--solo">
                  <div class="info-card__index">01</div>
                  <h3 class="info-card__title">C'est quoi ?</h3>
                  <p class="info-card__text">{{ p.description || 'Description non disponible.' }}</p>
                </article>
              </ng-template>

              <div class="docs" *ngIf="p.urlTerm || p.urlNote">
                <h3 class="docs__title">Documents</h3>
                <div class="docs__grid">
                  <a
                    class="doc-card"
                    *ngIf="p.urlTerm"
                    [href]="p.urlTerm"
                    target="_blank"
                    rel="noopener noreferrer">
                    <span class="doc-card__icon"><mat-icon>picture_as_pdf</mat-icon></span>
                    <span class="doc-card__body">
                      <span class="doc-card__label">Conditions générales</span>
                      <span class="doc-card__hint">Ouvrir le PDF</span>
                    </span>
                    <mat-icon class="doc-card__arrow">north_east</mat-icon>
                  </a>
                  <a
                    class="doc-card"
                    *ngIf="p.urlNote"
                    [href]="p.urlNote"
                    target="_blank"
                    rel="noopener noreferrer">
                    <span class="doc-card__icon doc-card__icon--note"><mat-icon>article</mat-icon></span>
                    <span class="doc-card__body">
                      <span class="doc-card__label">Note explicative</span>
                      <span class="doc-card__hint">Ouvrir le PDF</span>
                    </span>
                    <mat-icon class="doc-card__arrow">north_east</mat-icon>
                  </a>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">inventory_2</mat-icon>
              Packages
            </ng-template>

            <div class="tab-content">
              <div class="pack-list" *ngIf="getPackages(p).length; else noPackages">
                <article
                  class="pkg"
                  *ngFor="let pkg of getPackages(p); let i = index"
                  [style.animation-delay]="(i * 70) + 'ms'">
                  <div class="pkg__top">
                    <div class="pkg__badge">
                      {{ i + 1 | number:'2.0-0' }}
                    </div>
                    <div>
                      <h3 class="pkg__name">{{ pkg.name }}</h3>
                    </div>
                  </div>

                  <div class="pkg__formules" *ngIf="getGuarantees(pkg).length">
                    <section class="pkg__formule" *ngFor="let g of getGuarantees(pkg)">
                      <h4 class="pkg__formule-title">{{ sentenceCase(g.name) }}</h4>

                      <ng-container *ngIf="garantieContent(g) as content">
                        <ng-container *ngIf="content.rows.length">
                          <table class="pkg__table">
                            <thead>
                              <tr>
                                <th>Mise</th>
                                <th>Capital garanti</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of content.rows">
                                <td>{{ row.mise }}</td>
                                <td>: {{ row.capital }}</td>
                              </tr>
                            </tbody>
                          </table>

                          <p
                            class="pkg__formule-note"
                            *ngFor="let note of content.notes">
                            {{ note }}
                          </p>
                        </ng-container>

                        <p
                          class="pkg__formule-desc"
                          *ngIf="!content.rows.length && g.description">
                          {{ g.description }}
                        </p>
                      </ng-container>
                    </section>
                  </div>

                  <p class="pkg__empty-line" *ngIf="!getGuarantees(pkg).length">
                    Aucune garantie associée à ce package.
                  </p>
                </article>
              </div>

              <ng-template #noPackages>
                <div class="empty-pack">
                  <mat-icon>inventory_2</mat-icon>
                  <p>Aucun package disponible pour ce produit.</p>
                </div>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </section>
  </div>
</div>

<ng-template #notFound>
  <div class="page" *ngIf="!loading">
    <div class="page__glow" aria-hidden="true"></div>
    <div class="page__inner">
      <div class="state-card state-card--error">
        <mat-icon class="state-card__icon">search_off</mat-icon>
        <h2>Produit introuvable</h2>
        <p>{{ error || 'Le produit que vous cherchez n\'existe pas ou a été supprimé.' }}</p>
        <a class="btn btn--primary" routerLink="/accueil" fragment="produits">
          Retour aux produits
        </a>
      </div>
    </div>
  </div>
</ng-template>
